import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Field } from "../booking/StepFields";
import { api, apiError } from "../../lib/api";
import { fieldCls } from "../../lib/pricing";

const FIELDS = [
  ["company_name", "Razão social / nome da CONTRATADA", false],
  ["company_document", "CNPJ ou CPF", false],
  ["company_address", "Endereço da CONTRATADA", false],
  ["foro", "Comarca do foro", false],
  ["cancel_policy", "Cláusula 8 — cancelamento, reembolso e remarcação", true],
  ["contratada_extra", "Obrigações adicionais da CONTRATADA (opcional)", true],
  ["contratante_extra", "Obrigações adicionais do CONTRATANTE (opcional)", true],
];

export const CompanySettings = () => {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/company").then(({ data: d }) => setData(d ?? {})).catch((e) => toast.error(apiError(e)));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const body = Object.fromEntries(FIELDS.map(([k]) => [k, data?.[k] ?? ""]));
      const { data: d } = await api.put("/admin/company", body);
      setData(d);
      toast.success(`Contrato atualizado (versão ${d?.version}). Novos clientes precisarão aceitar esta versão.`);
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  if (!data) return null;
  return (
    <section data-testid="admin-company-settings" className="mt-14">
      <h2 className="font-display font-black uppercase text-2xl text-white">Contrato · dados da contratada</h2>
      <p className="text-sm text-zinc-400 mt-1">Versão atual do contrato: <b className="text-white" data-testid="admin-contract-version">{data.version}</b>. Ao salvar, a versão muda e só vale para novas contratações.</p>
      <div className="mt-6 grid md:grid-cols-2 gap-5">
        {FIELDS.map(([k, label, long]) => (
          <div key={k} className={long ? "md:col-span-2" : ""}>
            <Field label={label}>
              {long ? (
                <Textarea data-testid={`company-${k}`} rows={3} value={data[k] ?? ""} onChange={(e) => setData({ ...data, [k]: e.target.value })} className={`${fieldCls} h-auto py-3`} />
              ) : (
                <Input data-testid={`company-${k}`} value={data[k] ?? ""} onChange={(e) => setData({ ...data, [k]: e.target.value })} className={fieldCls} />
              )}
            </Field>
          </div>
        ))}
      </div>
      <button type="button" onClick={save} disabled={saving} data-testid="admin-company-save"
        className="mt-6 rounded-full bg-[#FFD200] text-[#08080C] font-semibold px-6 py-3 hover:bg-white disabled:opacity-60">Salvar dados do contrato</button>
    </section>
  );
};
